package puzzlekey

import kotlin.io.encoding.Base64
import kotlinx.serialization.KSerializer
import kotlinx.serialization.SerializationException
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

/**
 * The Bundle (CONTEXT.md): his message and the certificate, as JSON `{ message, mimeType, cert }` with
 * `cert` in base64. `seal` encrypts it into `sealed.json`; the site decrypts and shows it (T16).
 */
class Bundle(val message: String, val mimeType: String, val cert: ByteArray) {
    fun toBytes(): ByteArray = Json.encodeToString(Wire.serializer(), Wire(message, mimeType, Base64.encode(cert))).encodeToByteArray()

    companion object {
        /** Null when the decrypted bytes aren't a Bundle. */
        fun fromBytes(bytes: ByteArray): Bundle? =
            decodeOrNull(bytes, Wire.serializer())?.let { wire -> orNull { Bundle(wire.message, wire.mimeType, Base64.decode(wire.cert)) } }
    }

    @Serializable
    private class Wire(val message: String, val mimeType: String, val cert: String)
}

/** UTF-8 JSON bytes as [serializer]'s type; null when they aren't. */
internal fun <T> decodeOrNull(bytes: ByteArray, serializer: KSerializer<T>): T? =
    orNull { Json.decodeFromString(serializer, bytes.decodeToString(throwOnInvalidSequence = true)) }

private inline fun <T> orNull(decode: () -> T): T? =
    try {
        decode()
    } catch (e: SerializationException) {
        null
    } catch (e: IllegalArgumentException) {
        null // not UTF-8, or not base64
    } catch (e: CharacterCodingException) {
        null
    }
